import { styled } from '@mui/material/styles'
import MuiButton from '@mui/material/Button'

export const ButtonCompleted = styled(MuiButton, {
  name: 'ButtonCompleted',
  slot: 'Root',
  skipSx: true,
})`
  height: 30px;
  flex-direction: column;
  align-items: flex-start;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 22px;
  letter-spacing: 0.46px;
  display: flex;
`
